var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.861 33C39.909 33 39.953 33.013 40 33.014V11C40 7.686 37.314 5 34 5H14C10.686 5 8 7.686 8 11V37H34.962C35.425 34.718 37.442 33 39.861 33Z",
    fill: "#34C759"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43H13C10.239 43 8 40.761 8 38C8 35.239 10.239 33 13 33H40C40 33 35 33.208 35 38C35 42.792 40 43 40 43Z",
    fill: "#C4C5CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34C40.553 34 41 33.553 41 33V11C41 7.14 37.859 4 34 4H14C10.14 4 7 7.14 7 11V38C7 41.309 9.691 44 13 44H40C40.553 44 41 43.553 41 43C41 42.447 40.553 42 40 42C37.794 42 36 40.206 36 38C36 35.794 37.794 34 40 34ZM14 6H34C36.757 6 39 8.243 39 11V32H13C11.462 32 10.063 32.586 9 33.54V11C9 8.243 11.243 6 14 6ZM13 42C10.794 42 9 40.206 9 38C9 35.794 10.794 34 13 34H35.54C34.586 35.063 34 36.462 34 38C34 39.538 34.586 40.937 35.54 42H13Z",
    fill: "#505363"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14H15C14.448 14 14 13.552 14 13C14 12.448 14.448 12 15 12H33C33.553 12 34 12.448 34 13C34 13.552 33.553 14 33 14Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 20H15C14.448 20 14 19.552 14 19C14 18.448 14.448 18 15 18H33C33.553 18 34 18.448 34 19C34 19.552 33.553 20 33 20Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33 26H15C14.448 26 14 25.553 14 25C14 24.448 14.448 24 15 24H33C33.553 24 34 24.448 34 25C34 25.553 33.553 26 33 26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.3d24e210eab0f871f988c19f9be2da35.svg";
export { ForwardRef as ReactComponent };